DialogHandler = App.loadClass 'portal::handlers/zones/AddEditDialog'
ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.AddEditDialogWithGrower extends DialogHandler

    init: =>
        @ppID = @parent.ppID

        @layoutUrl = 'backend/portal/zones/zones/load-add-edit-dialog-with-grower'
        @loadLayoutPostOptions ?= {}
        @loadLayoutPostOptions.pp_id = @ppID

        @saveUrl = 'backend/portal/zones/zones/save'

        @classes = 'medium_dialog add_edit_zone_dialog'
        @createDialog()
        @openDialog()
        @displayLoadingMessage('Loading Zone...')

        @validator = new ValidationEngine()


    afterLoadLayout: (selector, response) =>
        if response.status?.type isnt 'success'
            return

        super(selector, response)

        # validation
        @validator.makeFormValidator 'step1', '#frm_edit_zones .step1', '#step1_errors', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                @goToStep2()
            else
                # Perform an action if the form validation failed


        @dialog.find('.counties-btn').on 'click', =>
            @goToStep1()

        @dialog.find('.ranges-btn').on 'click', =>
            @validator.validateForm('step1')

        @goToStep1()


    goToStep1: =>
        @dialog.find('.step2').hide()
        @dialog.find('.step1').show()

        @dialog.find('.counties-btn').hide()
        @dialog.find('.save-btn').hide()

        @dialog.find('.cancel-btn').show()
        @dialog.find('.ranges-btn').show()

        @setPosition()


    goToStep2: =>
        @dialog.find('.step1').hide()
        @dialog.find('.step2').show()

        @dialog.find('.cancel-btn').hide()
        @dialog.find('.ranges-btn').hide()

        @dialog.find('.counties-btn').show()
        @dialog.find('.save-btn').show()

        @setPosition()
